import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-notification',
  templateUrl: './profile-notification.component.html',
  styleUrls: ['./profile-notification.component.scss']
})
export class ProfileNotificationComponent implements OnInit {
  @Input() notificationCount: number;

  constructor() { }

  ngOnInit(): void { }

}
